import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getOptionFromValueTimePeriod} from '../../PlanTemplates/ACC/benefitDefaults';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFacilityCarePath} from './PropertyPaths/accidentFacilityCarePath';

export const ObjectiveSecondOpinion = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = accidentFacilityCarePath(selectedPlan?.planIndex ?? 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'initial-hospital-row-1'},
      items: [
        {
          key: propertyPaths.objectiveSecondOpinionDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.objectiveSecondOpinionDetails.incurralPeriod)}
              id={propertyPaths.objectiveSecondOpinionDetails.incurralPeriod}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.objectiveSecondOpinionDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.objectiveSecondOpinionDetails.customizeBenefitAmount)}
              id={propertyPaths.objectiveSecondOpinionDetails.customizeBenefitAmount}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'initial-hospital-row-2'},
      items: [
        {
          key: propertyPaths.objectiveSecondOpinionDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount (Per Day)"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.objectiveSecondOpinionDetails.benefitAmount)
              )}
              id={propertyPaths.objectiveSecondOpinionDetails.benefitAmount}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.objectiveSecondOpinionDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Number of Days per Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.objectiveSecondOpinionDetails.maxBenefitNumber)}
              id={propertyPaths.objectiveSecondOpinionDetails.maxBenefitNumber}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'initial-hospital-row-3'},
      items: [
        {
          key: propertyPaths.objectiveSecondOpinionDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Time Period"
              options={getOptionFromValueTimePeriod(
                getQuoteFieldValue<string>(propertyPaths.objectiveSecondOpinionDetails.timePeriodCd) ?? ''
              )}
              value={getQuoteFieldValue<number>(propertyPaths.objectiveSecondOpinionDetails.timePeriodCd)}
              id={propertyPaths.objectiveSecondOpinionDetails.timePeriodCd}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
